import { memo, useEffect, useState } from "react";
import { useNotifyModalState } from "lib/useNotifyModalState";
import { loadPrefs, browserNotificationState } from "lib/notifications/notificationPrefs";

import "./NotifyButton.scss";

import BellIcon from "img/bell.svg?react";

export const NotifyButton = memo(function NotifyButton() {
  const { openNotifyModal } = useNotifyModalState();
  const [active, setActive] = useState(false);

  useEffect(() => {
    const check = () => {
      const prefs = loadPrefs();
      setActive(prefs.browserEnabled && browserNotificationState() === "granted");
    };
    check();
    // Re-check whenever localStorage changes (other tabs / modal save)
    window.addEventListener("storage", check);
    return () => window.removeEventListener("storage", check);
  }, []);

  return (
    <div className={`NotifyButton ${active ? "NotifyButton--active" : ""}`} onClick={openNotifyModal} title="Notifications">
      <BellIcon className="NotifyButton-icon" />
      {active && <span className="NotifyButton-dot" />}
    </div>
  );
});
